import restaurantBookingService from '@/api/restaurantbooking'
import { RESTAURANT_BOOKING } from '../types'
import errorhandler from '@/utils/errorhandler.js'
import Vue from 'vue'

const proto = Vue.prototype

export default {
  namespaced: true,
  state: {
    dates: [],
    owners: [],
    restaurantId: null,
    slots: [],
    mealSlots: [],
    slotId: null,
    loadedFirstTime: false,
    queryFilter: '',
    restaurantQueryFilter: '',
    filterDate: null,
    restaurantBookings: [],
    mealSlotsSelected: {},
    userBookedDates: []
  },
  getters:{
    dates: (state) => {
      return state.dates
    },
    restaurantId: (state) => {
      return state.restaurantId
    },
    slotId: (state) => {
      return state.slotId
    },
    fullDate: (state) => {
      return proto.$moment(state.dates[0]).utc().toISOString()
    },
    fullDates: (state) => {
      return state.dates.map(date => proto.$moment(date).utc().toISOString())
    },
    loadedFirstTime: (state) =>{
      return state.loadedFirstTime
    },
    queryFilter: (state) => {
      return state.queryFilter
    },
    restaurantQueryFilter: (state) => {
      return state.restaurantQueryFilter
    },
    filterDate: (state) => {
      return state.filterDate
    },
    restaurantBookings: (state) => {
      return state.restaurantBookings
    },
    userBookedDates: (state) => {
      return state.userBookedDates
    },
    owner: (state) => {
      return state.owners[0].email
    }
  },
  mutations: {
    [RESTAURANT_BOOKING.SET_DATES] (state, dates) {
      state.dates = dates
    },
    [RESTAURANT_BOOKING.SELECT_OWNER] (state, item) {
      state.owners.splice(0, 1)
      state.owners.push(item)
    },
    [RESTAURANT_BOOKING.REMOVE_OWNER] (state, index) {
      state.owners.splice(index, 1)
    },
    [RESTAURANT_BOOKING.SET_RESTAURANT] (state, restaurantId) {
      state.restaurantId = restaurantId
    },
    [RESTAURANT_BOOKING.SET_SLOTS] (state, slots) {
      state.slots = slots
    },
    [RESTAURANT_BOOKING.SET_MEAL_SLOTS] (state, mealSlots) {
      state.mealSlots = mealSlots
    },
    [RESTAURANT_BOOKING.SET_SLOTID] (state, slotId) {
      state.slotId = slotId
    },
    [RESTAURANT_BOOKING.SET_MEAL_SLOTS_SELECTED] (state, mealSlotsSelected) {
      state.mealSlotsSelected = mealSlotsSelected
    },
    [RESTAURANT_BOOKING.SET_LOADED_FIRST_TIME] (state, loadedFirstTime) {
      state.loadedFirstTime = loadedFirstTime
    },
    [RESTAURANT_BOOKING.SET_QUERY_FILTER] (state, queryFilter) {
      state.queryFilter = queryFilter
    },
    [RESTAURANT_BOOKING.SET_RESTAURANT_QUERY_FILTER] (state, restaurantQueryFilter) {
      state.restaurantQueryFilter = restaurantQueryFilter
    },
    [RESTAURANT_BOOKING.SET_FILTER_DATE] (state, filterDate) {
      state.filterDate = filterDate
    },
    [RESTAURANT_BOOKING.SET_RESTAURANT_BOOKINGS] (state, restaurantBookings) {
      state.restaurantBookings = restaurantBookings
    },
    [RESTAURANT_BOOKING.SET_USER_BOOKED_DATES] (state, userBookedDates) {
      state.userBookedDates = userBookedDates
    }
  },
  actions: {
    setDates({commit}, dates) {
      commit(RESTAURANT_BOOKING.SET_DATES, dates)
    },
    selectOwner ({ commit, }, item) {
      let owner = item.email? {email: item.email, name: item.name} : {email: item}
      commit(RESTAURANT_BOOKING.SELECT_OWNER, owner)
    },
    removeOwner ({ commit }, index) {
      commit(RESTAURANT_BOOKING.REMOVE_OWNER, index)
    },
    setRestaurant ({commit}, restaurantId) {
      commit(RESTAURANT_BOOKING.SET_RESTAURANT, restaurantId)
    },
    setSlotId ({commit}, slotId) {
      commit(RESTAURANT_BOOKING.SET_SLOTID, slotId)
    },
    setMealSlotsSelected ({commit}, mealSlotsSelected) {
      commit(RESTAURANT_BOOKING.SET_MEAL_SLOTS_SELECTED, mealSlotsSelected)
    },
    setLoadedFirstTime ({commit}, loadedFirstTime) {
      commit(RESTAURANT_BOOKING.SET_LOADED_FIRST_TIME, loadedFirstTime)
    },
    setQueryFilter ({commit}, queryFilter) {
      commit(RESTAURANT_BOOKING.SET_QUERY_FILTER, queryFilter)
    },
    setFilterDate ({commit}, filterDate) {
      commit(RESTAURANT_BOOKING.SET_FILTER_DATE, filterDate)
    },
    setRestaurantQueryFilter ({commit}, restaurantQueryFilter) {
      commit(RESTAURANT_BOOKING.SET_RESTAURANT_QUERY_FILTER, restaurantQueryFilter)
    },
    async getSlots ({getters, commit, state}, siteId) {
      const restaurantId = state.restaurantId
      try {
        let response = await restaurantBookingService.getSlots(restaurantId, siteId, getters.fullDates)
        commit(RESTAURANT_BOOKING.SET_SLOTS, response.data)
      }
      catch (error){
        return Promise.reject(error)
      }
    },
    async getMealSlots ({getters, commit, state}) {
      const restaurantId = state.restaurantId
      try {
        let response = await restaurantBookingService.getMealSlots(restaurantId, getters.fullDate)
        commit(RESTAURANT_BOOKING.SET_MEAL_SLOTS, response.data)
      }
      catch (error){
        return Promise.reject(error)
      }
    },
    async saveBookingOfAnUser ({dispatch, state, getters, rootState}) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        const userEmail = state.owners[0].email
        if(rootState.Global.initialSettings.restaurants.hasMeal){
          const dishes = []
          Object.values(state.mealSlotsSelected).forEach((mealSlotSelected) => {
            dishes.push(mealSlotSelected)
          })

          const date = getters.fullDate
          const body = {
            userEmail,
            date,
            dishes
          }
          await restaurantBookingService.createBookingWithMealOfAnUser(state.restaurantId, body)
        } else {
          const slotId = state.slotId
          const dates = getters.fullDates

          const body = {
            userEmail,
            dates,
            slotId
          }
          await restaurantBookingService.createBookingOfAnUser(state.restaurantId, body)
        }
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveBooking ({dispatch, state, getters}) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        const userEmail = state.owners[0].email
        const date =  getters.fullDate
        const slotId = state.slotId

        const body = {
          userEmail,
          date,
          slotId
        }
        await restaurantBookingService.createBooking(state.restaurantId, body)
        if(state.filterDate && state.restaurantQueryFilter){
          dispatch('RestaurantBooking/getRestaurantsWithBookingsWithFilter', null, {root: true})
        }
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async deleteRestaurantBooking ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await restaurantBookingService.deleteBooking(payload.restaurant.id, payload.booking.id)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async manageDeleteRestaurantBooking ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await restaurantBookingService.manageDeleteBooking(payload.restaurant.id, payload.booking.id)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async getRestaurantsWithBookingsWithFilter({dispatch, state, commit}){
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve) => {
        const date = proto.$moment(state.filterDate).utc().format()
        restaurantBookingService.getRestaurantsWithBookingsWithFilter(state.queryFilter, state.restaurantQueryFilter, date).then((response) => {
            commit(RESTAURANT_BOOKING.SET_RESTAURANT_BOOKINGS, response.data)
            resolve()
        }).catch(() => {
            commit(RESTAURANT_BOOKING.SET_RESTAURANT_BOOKINGS, [])
        }).finally(
            dispatch('Global/hideLoading', null, { root: true })
        )
      })
    },
    async getUserBookedDates({dispatch, commit}, payload) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        const response = await restaurantBookingService.getUserBookedDates(payload.start, payload.end)
        commit(RESTAURANT_BOOKING.SET_USER_BOOKED_DATES, response.data)
      } catch (error) {
        errorhandler.handleError(error);
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    clearFilters: function ({commit}) {
      commit(RESTAURANT_BOOKING.SET_QUERY_FILTER, null)
      commit(RESTAURANT_BOOKING.SET_RESTAURANT_QUERY_FILTER, null)
      commit(RESTAURANT_BOOKING.SET_RESTAURANT_BOOKINGS, [])
    },
    clearRestaurantBookings: function ({commit}) {
      commit(RESTAURANT_BOOKING.SET_RESTAURANT_BOOKINGS, [])
    }
  }
}
